// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-B":"B_shp2-detail-B__7gGuu"};